export default {
    grupoEquipamentos: [],
    grupoEquipamento: {}
}